mod.modules.define("SecurityCommentary", "BaseModule", function(fn) {
	"use strict";

	fn.prototype.init = function (params) {
		this.base("init", params);

		this.arrow = $("span.commentary-arrow", this.el);

		var activeCommentary = $("table.commentary-timeline a.active", this.el);
		this.positionArrow(activeCommentary);
	};

	fn.prototype.positionArrow = function ($activeCommentary) {
		if ($activeCommentary.length > 0) {
			var childPosition = $activeCommentary.position().left
			var parentPosition = $activeCommentary
				.closest("td")
				.position()
				.left;
			
			var offsetLeft = (parentPosition + childPosition) - 4;

			this.arrow.css("left", offsetLeft);
		}
	};

	fn.prototype.loadCommentary = function (e, $el) {
		var self = this;
		e.preventDefault();

		if (!$el.hasClass("active")) {
			//update timeline highlighting
			this.el.find("table.commentary-timeline a.active").removeClass("active");
			$el.addClass("active");
			this.positionArrow($el);

			var loadData = {
				SelectedQtr: null,
				SelectedYear: null,
				ResearchNoteDate: null
			};

			if ($el.data("date") !== undefined) {
				loadData.ResearchNoteDate = $el.data("date");
			}
			else {
				loadData.SelectedQtr = $el.data("qtr");
				loadData.SelectedYear = $el.data("year");
			}

			this.updatePrint(loadData);

			this.ajax(loadData, function (response) { self.updateCommentary(response); });
		}
	};

	fn.prototype.updatePrint = function (newParams) {
		//Update print button
		var printLink = $("A.action-print", this.el);
		var context = $.extend({}, this.getContext(), newParams);
		this.setContext(context);

		if (printLink.length > 0) { //Update the print link
			var contextSearch = "context:";			

			if (context["PrintView"] == undefined) { //reinsert it for this
				context["PrintView"] = true;
			}

			var rawPrintURL = printLink.attr("href");
			var printURL = rawPrintURL.substring(0, rawPrintURL.indexOf(contextSearch) + contextSearch.length);
			var serContext = JSON.stringify(context);
			var params = printURL + serContext + "}]";

			printLink.attr("href", params);
		}
	};

	fn.prototype.updateCommentary = function (response) {
		if (response.html) {
			var $container = this.el.find("div.commentarySection");
			$container.replaceWith(response.html);
		}
	};

	fn.prototype.events = {
		"table.commentary-timeline a": {
			"click": function (e, $el) {
				this.loadCommentary(e, $el);
			}
		}
	};

});